
/* !!! This is code generated by Prisma. Do not edit directly. !!!
/* eslint-disable */

Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.8.2
 * Query Engine version: 2060c79ba17c6bb9f5823312b6f6b7f4a845738e
 */
Prisma.prismaVersion = {
  client: "6.8.2",
  engine: "2060c79ba17c6bb9f5823312b6f6b7f4a845738e"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  telephone: 'telephone',
  prenom: 'prenom',
  nom_de_famille: 'nom_de_famille',
  numero_cfei: 'numero_cfei',
  prochain_bracelet_a_utiliser: 'prochain_bracelet_a_utiliser',
  addresse_ligne_1: 'addresse_ligne_1',
  addresse_ligne_2: 'addresse_ligne_2',
  code_postal: 'code_postal',
  ville: 'ville',
  user_entities_vivible_checkbox: 'user_entities_vivible_checkbox',
  roles: 'roles',
  created_at: 'created_at',
  updated_at: 'updated_at',
  last_login_at: 'last_login_at',
  last_seen_at: 'last_seen_at',
  deleted_at: 'deleted_at',
  onboarded_at: 'onboarded_at',
  notifications: 'notifications',
  web_push_tokens: 'web_push_tokens',
  prefilled: 'prefilled',
  activated: 'activated',
  activated_at: 'activated_at',
  is_synced: 'is_synced',
  brevo_contact_id: 'brevo_contact_id',
  at_least_one_fei_treated: 'at_least_one_fei_treated'
};

exports.Prisma.EntityScalarFieldEnum = {
  id: 'id',
  raison_sociale: 'raison_sociale',
  nom_d_usage: 'nom_d_usage',
  address_ligne_1: 'address_ligne_1',
  address_ligne_2: 'address_ligne_2',
  code_postal: 'code_postal',
  ville: 'ville',
  siret: 'siret',
  nom_prenom_responsable: 'nom_prenom_responsable',
  prefecture_svi: 'prefecture_svi',
  ccg_status: 'ccg_status',
  numero_ddecpp: 'numero_ddecpp',
  inc_certificat: 'inc_certificat',
  inc_decision: 'inc_decision',
  code_etbt_certificat: 'code_etbt_certificat',
  type: 'type',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at',
  onboarded_at: 'onboarded_at',
  prefilled: 'prefilled',
  is_synced: 'is_synced',
  brevo_id: 'brevo_id',
  at_least_one_fei_treated: 'at_least_one_fei_treated'
};

exports.Prisma.PasswordScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  password: 'password',
  reset_password_last_email_sent_at: 'reset_password_last_email_sent_at',
  reset_password_token: 'reset_password_token',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at'
};

exports.Prisma.UserRelationsScalarFieldEnum = {
  id: 'id',
  owner_id: 'owner_id',
  related_id: 'related_id',
  relation: 'relation',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at',
  is_synced: 'is_synced'
};

exports.Prisma.EntityAndUserRelationsScalarFieldEnum = {
  id: 'id',
  owner_id: 'owner_id',
  entity_id: 'entity_id',
  relation: 'relation',
  brevo_id: 'brevo_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at',
  is_synced: 'is_synced'
};

exports.Prisma.ETGAndEntityRelationsScalarFieldEnum = {
  etg_id_entity_id: 'etg_id_entity_id',
  etg_id: 'etg_id',
  entity_id: 'entity_id',
  entity_type: 'entity_type',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at',
  brevo_id: 'brevo_id',
  is_synced: 'is_synced'
};

exports.Prisma.LogScalarFieldEnum = {
  id: 'id',
  user_id: 'user_id',
  user_role: 'user_role',
  fei_numero: 'fei_numero',
  entity_id: 'entity_id',
  zacharie_carcasse_id: 'zacharie_carcasse_id',
  fei_intermediaire_id: 'fei_intermediaire_id',
  intermediaire_id: 'intermediaire_id',
  carcasse_intermediaire_id: 'carcasse_intermediaire_id',
  action: 'action',
  history: 'history',
  date: 'date',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at',
  is_synced: 'is_synced'
};

exports.Prisma.FeiScalarFieldEnum = {
  id: 'id',
  numero: 'numero',
  date_mise_a_mort: 'date_mise_a_mort',
  commune_mise_a_mort: 'commune_mise_a_mort',
  heure_mise_a_mort_premiere_carcasse: 'heure_mise_a_mort_premiere_carcasse',
  heure_evisceration_derniere_carcasse: 'heure_evisceration_derniere_carcasse',
  created_by_user_id: 'created_by_user_id',
  resume_nombre_de_carcasses: 'resume_nombre_de_carcasses',
  automatic_closed_at: 'automatic_closed_at',
  examinateur_initial_offline: 'examinateur_initial_offline',
  examinateur_initial_user_id: 'examinateur_initial_user_id',
  examinateur_initial_approbation_mise_sur_le_marche: 'examinateur_initial_approbation_mise_sur_le_marche',
  examinateur_initial_date_approbation_mise_sur_le_marche: 'examinateur_initial_date_approbation_mise_sur_le_marche',
  premier_detenteur_offline: 'premier_detenteur_offline',
  premier_detenteur_user_id: 'premier_detenteur_user_id',
  premier_detenteur_entity_id: 'premier_detenteur_entity_id',
  premier_detenteur_name_cache: 'premier_detenteur_name_cache',
  premier_detenteur_depot_type: 'premier_detenteur_depot_type',
  premier_detenteur_depot_entity_id: 'premier_detenteur_depot_entity_id',
  premier_detenteur_depot_ccg_at: 'premier_detenteur_depot_ccg_at',
  premier_detenteur_transport_type: 'premier_detenteur_transport_type',
  premier_detenteur_transport_date: 'premier_detenteur_transport_date',
  premier_detenteur_prochain_detenteur_type_cache: 'premier_detenteur_prochain_detenteur_type_cache',
  premier_detenteur_prochain_detenteur_id_cache: 'premier_detenteur_prochain_detenteur_id_cache',
  intermediaire_closed_at: 'intermediaire_closed_at',
  intermediaire_closed_by_user_id: 'intermediaire_closed_by_user_id',
  intermediaire_closed_by_entity_id: 'intermediaire_closed_by_entity_id',
  svi_assigned_at: 'svi_assigned_at',
  svi_entity_id: 'svi_entity_id',
  svi_user_id: 'svi_user_id',
  svi_closed_at: 'svi_closed_at',
  svi_closed_by_user_id: 'svi_closed_by_user_id',
  fei_current_owner_user_id: 'fei_current_owner_user_id',
  fei_current_owner_user_name_cache: 'fei_current_owner_user_name_cache',
  fei_current_owner_entity_id: 'fei_current_owner_entity_id',
  fei_current_owner_entity_name_cache: 'fei_current_owner_entity_name_cache',
  fei_current_owner_role: 'fei_current_owner_role',
  fei_current_owner_wants_to_transfer: 'fei_current_owner_wants_to_transfer',
  fei_next_owner_user_id: 'fei_next_owner_user_id',
  fei_next_owner_user_name_cache: 'fei_next_owner_user_name_cache',
  fei_next_owner_entity_id: 'fei_next_owner_entity_id',
  fei_next_owner_entity_name_cache: 'fei_next_owner_entity_name_cache',
  fei_next_owner_role: 'fei_next_owner_role',
  fei_prev_owner_user_id: 'fei_prev_owner_user_id',
  fei_prev_owner_entity_id: 'fei_prev_owner_entity_id',
  fei_prev_owner_role: 'fei_prev_owner_role',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at',
  is_synced: 'is_synced'
};

exports.Prisma.CarcasseScalarFieldEnum = {
  zacharie_carcasse_id: 'zacharie_carcasse_id',
  numero_bracelet: 'numero_bracelet',
  fei_numero: 'fei_numero',
  espece: 'espece',
  type: 'type',
  nombre_d_animaux: 'nombre_d_animaux',
  heure_mise_a_mort: 'heure_mise_a_mort',
  heure_evisceration: 'heure_evisceration',
  examinateur_carcasse_sans_anomalie: 'examinateur_carcasse_sans_anomalie',
  examinateur_anomalies_carcasse: 'examinateur_anomalies_carcasse',
  examinateur_anomalies_abats: 'examinateur_anomalies_abats',
  examinateur_commentaire: 'examinateur_commentaire',
  examinateur_signed_at: 'examinateur_signed_at',
  intermediaire_carcasse_refus_intermediaire_id: 'intermediaire_carcasse_refus_intermediaire_id',
  intermediaire_carcasse_refus_motif: 'intermediaire_carcasse_refus_motif',
  intermediaire_carcasse_manquante: 'intermediaire_carcasse_manquante',
  latest_intermediaire_signed_at: 'latest_intermediaire_signed_at',
  svi_assigned_to_fei_at: 'svi_assigned_to_fei_at',
  svi_carcasse_commentaire: 'svi_carcasse_commentaire',
  svi_carcasse_status: 'svi_carcasse_status',
  svi_carcasse_status_set_at: 'svi_carcasse_status_set_at',
  svi_ipm1_date: 'svi_ipm1_date',
  svi_ipm1_presentee_inspection: 'svi_ipm1_presentee_inspection',
  svi_ipm1_user_id: 'svi_ipm1_user_id',
  svi_ipm1_user_name_cache: 'svi_ipm1_user_name_cache',
  svi_ipm1_protocole: 'svi_ipm1_protocole',
  svi_ipm1_pieces: 'svi_ipm1_pieces',
  svi_ipm1_lesions_ou_motifs: 'svi_ipm1_lesions_ou_motifs',
  svi_ipm1_nombre_animaux: 'svi_ipm1_nombre_animaux',
  svi_ipm1_commentaire: 'svi_ipm1_commentaire',
  svi_ipm1_decision: 'svi_ipm1_decision',
  svi_ipm1_duree_consigne: 'svi_ipm1_duree_consigne',
  svi_ipm1_poids_consigne: 'svi_ipm1_poids_consigne',
  svi_ipm1_signed_at: 'svi_ipm1_signed_at',
  svi_ipm2_date: 'svi_ipm2_date',
  svi_ipm2_presentee_inspection: 'svi_ipm2_presentee_inspection',
  svi_ipm2_user_id: 'svi_ipm2_user_id',
  svi_ipm2_user_name_cache: 'svi_ipm2_user_name_cache',
  svi_ipm2_protocole: 'svi_ipm2_protocole',
  svi_ipm2_pieces: 'svi_ipm2_pieces',
  svi_ipm2_lesions_ou_motifs: 'svi_ipm2_lesions_ou_motifs',
  svi_ipm2_nombre_animaux: 'svi_ipm2_nombre_animaux',
  svi_ipm2_commentaire: 'svi_ipm2_commentaire',
  svi_ipm2_decision: 'svi_ipm2_decision',
  svi_ipm2_traitement_assainissant: 'svi_ipm2_traitement_assainissant',
  svi_ipm2_traitement_assainissant_cuisson_temps: 'svi_ipm2_traitement_assainissant_cuisson_temps',
  svi_ipm2_traitement_assainissant_cuisson_temp: 'svi_ipm2_traitement_assainissant_cuisson_temp',
  svi_ipm2_traitement_assainissant_congelation_temps: 'svi_ipm2_traitement_assainissant_congelation_temps',
  svi_ipm2_traitement_assainissant_congelation_temp: 'svi_ipm2_traitement_assainissant_congelation_temp',
  svi_ipm2_traitement_assainissant_type: 'svi_ipm2_traitement_assainissant_type',
  svi_ipm2_traitement_assainissant_paramètres: 'svi_ipm2_traitement_assainissant_paramètres',
  svi_ipm2_traitement_assainissant_etablissement: 'svi_ipm2_traitement_assainissant_etablissement',
  svi_ipm2_traitement_assainissant_poids: 'svi_ipm2_traitement_assainissant_poids',
  svi_ipm2_poids_saisie: 'svi_ipm2_poids_saisie',
  svi_ipm2_signed_at: 'svi_ipm2_signed_at',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at',
  is_synced: 'is_synced'
};

exports.Prisma.CarcasseCertificatScalarFieldEnum = {
  certificat_id: 'certificat_id',
  zacharie_carcasse_id: 'zacharie_carcasse_id',
  remplace_certificat_id: 'remplace_certificat_id',
  numero_decision: 'numero_decision',
  numero_decision_ipm1: 'numero_decision_ipm1',
  type: 'type',
  prefecture_svi: 'prefecture_svi',
  commune_etg: 'commune_etg',
  date_consigne: 'date_consigne',
  lieu_consigne: 'lieu_consigne',
  nom_etg_personne_physique: 'nom_etg_personne_physique',
  nom_etg_personne_morale: 'nom_etg_personne_morale',
  siret_etg: 'siret_etg',
  traitement_assainissant_etablissement: 'traitement_assainissant_etablissement',
  traitement_type: 'traitement_type',
  traitement_parametre: 'traitement_parametre',
  fei_numero: 'fei_numero',
  numero_bracelet: 'numero_bracelet',
  espece: 'espece',
  carcasse_type: 'carcasse_type',
  nombre_d_animaux: 'nombre_d_animaux',
  date_mise_a_mort: 'date_mise_a_mort',
  commune_mise_a_mort: 'commune_mise_a_mort',
  examinateur_initial: 'examinateur_initial',
  premier_detenteur: 'premier_detenteur',
  collecteur_pro: 'collecteur_pro',
  pieces: 'pieces',
  motifs: 'motifs',
  commentaire: 'commentaire',
  poids: 'poids',
  svi_ipm1_signed_at: 'svi_ipm1_signed_at',
  svi_ipm2_signed_at: 'svi_ipm2_signed_at',
  duree_consigne: 'duree_consigne',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.FeiIntermediaireScalarFieldEnum = {
  id: 'id',
  fei_numero: 'fei_numero',
  fei_intermediaire_offline: 'fei_intermediaire_offline',
  fei_intermediaire_user_id: 'fei_intermediaire_user_id',
  fei_intermediaire_entity_id: 'fei_intermediaire_entity_id',
  fei_intermediaire_role: 'fei_intermediaire_role',
  commentaire: 'commentaire',
  received_at: 'received_at',
  check_finished_at: 'check_finished_at',
  handover_at: 'handover_at',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at',
  is_synced: 'is_synced'
};

exports.Prisma.CarcasseIntermediaireScalarFieldEnum = {
  fei_numero: 'fei_numero',
  numero_bracelet: 'numero_bracelet',
  zacharie_carcasse_id: 'zacharie_carcasse_id',
  prise_en_charge: 'prise_en_charge',
  check_manuel: 'check_manuel',
  manquante: 'manquante',
  refus: 'refus',
  commentaire: 'commentaire',
  carcasse_check_finished_at: 'carcasse_check_finished_at',
  fei_numero__bracelet__intermediaire_id: 'fei_numero__bracelet__intermediaire_id',
  fei_intermediaire_id: 'fei_intermediaire_id',
  fei_intermediaire_user_id: 'fei_intermediaire_user_id',
  fei_intermediaire_entity_id: 'fei_intermediaire_entity_id',
  decision_at: 'decision_at',
  prise_en_charge_at: 'prise_en_charge_at',
  intermediaire_id: 'intermediaire_id',
  intermediaire_entity_id: 'intermediaire_entity_id',
  intermediaire_role: 'intermediaire_role',
  intermediaire_user_id: 'intermediaire_user_id',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at',
  is_synced: 'is_synced'
};

exports.Prisma.NotificationLogScalarFieldEnum = {
  id: 'id',
  type: 'type',
  email: 'email',
  web_push_token: 'web_push_token',
  user_id: 'user_id',
  action: 'action',
  payload: 'payload',
  created_at: 'created_at',
  updated_at: 'updated_at',
  deleted_at: 'deleted_at'
};

exports.Prisma.CronJobScalarFieldEnum = {
  id: 'id',
  unique_key: 'unique_key',
  name: 'name',
  active: 'active',
  created_at: 'created_at',
  updated_at: 'updated_at'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.UserRoles = exports.$Enums.UserRoles = {
  ADMIN: 'ADMIN',
  EXAMINATEUR_INITIAL: 'EXAMINATEUR_INITIAL',
  PREMIER_DETENTEUR: 'PREMIER_DETENTEUR',
  CCG: 'CCG',
  COLLECTEUR_PRO: 'COLLECTEUR_PRO',
  ETG: 'ETG',
  SVI: 'SVI'
};

exports.UserNotifications = exports.$Enums.UserNotifications = {
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  PUSH: 'PUSH'
};

exports.EntityTypes = exports.$Enums.EntityTypes = {
  PREMIER_DETENTEUR: 'PREMIER_DETENTEUR',
  COLLECTEUR_PRO: 'COLLECTEUR_PRO',
  CCG: 'CCG',
  ETG: 'ETG',
  SVI: 'SVI'
};

exports.UserRelationType = exports.$Enums.UserRelationType = {
  PREMIER_DETENTEUR: 'PREMIER_DETENTEUR',
  EXAMINATEUR_INITIAL: 'EXAMINATEUR_INITIAL'
};

exports.EntityRelationType = exports.$Enums.EntityRelationType = {
  WORKING_FOR: 'WORKING_FOR',
  WORKING_WITH: 'WORKING_WITH'
};

exports.DepotType = exports.$Enums.DepotType = {
  CCG: 'CCG',
  ETG: 'ETG',
  AUCUN: 'AUCUN'
};

exports.TransportType = exports.$Enums.TransportType = {
  PREMIER_DETENTEUR: 'PREMIER_DETENTEUR',
  ETG: 'ETG',
  COLLECTEUR_PRO: 'COLLECTEUR_PRO',
  AUCUN: 'AUCUN'
};

exports.CarcasseType = exports.$Enums.CarcasseType = {
  PETIT_GIBIER: 'PETIT_GIBIER',
  GROS_GIBIER: 'GROS_GIBIER'
};

exports.CarcasseStatus = exports.$Enums.CarcasseStatus = {
  MANQUANTE_ETG_COLLECTEUR: 'MANQUANTE_ETG_COLLECTEUR',
  REFUS_ETG_COLLECTEUR: 'REFUS_ETG_COLLECTEUR',
  SANS_DECISION: 'SANS_DECISION',
  ACCEPTE: 'ACCEPTE',
  CONSIGNE: 'CONSIGNE',
  MANQUANTE_SVI: 'MANQUANTE_SVI',
  SAISIE_TOTALE: 'SAISIE_TOTALE',
  SAISIE_PARTIELLE: 'SAISIE_PARTIELLE',
  LEVEE_DE_CONSIGNE: 'LEVEE_DE_CONSIGNE',
  TRAITEMENT_ASSAINISSANT: 'TRAITEMENT_ASSAINISSANT'
};

exports.IPM1Protocole = exports.$Enums.IPM1Protocole = {
  STANDARD: 'STANDARD',
  RENFORCE: 'RENFORCE'
};

exports.IPM1Decision = exports.$Enums.IPM1Decision = {
  NON_RENSEIGNEE: 'NON_RENSEIGNEE',
  MISE_EN_CONSIGNE: 'MISE_EN_CONSIGNE'
};

exports.IPM2Decision = exports.$Enums.IPM2Decision = {
  NON_RENSEIGNEE: 'NON_RENSEIGNEE',
  LEVEE_DE_LA_CONSIGNE: 'LEVEE_DE_LA_CONSIGNE',
  SAISIE_TOTALE: 'SAISIE_TOTALE',
  SAISIE_PARTIELLE: 'SAISIE_PARTIELLE',
  TRAITEMENT_ASSAINISSANT: 'TRAITEMENT_ASSAINISSANT'
};

exports.IPM2Traitement = exports.$Enums.IPM2Traitement = {
  CUISSON: 'CUISSON',
  CONGELATION: 'CONGELATION',
  AUTRE: 'AUTRE'
};

exports.CarcasseCertificatType = exports.$Enums.CarcasseCertificatType = {
  CC: 'CC',
  CSP: 'CSP',
  CST: 'CST',
  LC: 'LC',
  LPS: 'LPS'
};

exports.Prisma.ModelName = {
  User: 'User',
  Entity: 'Entity',
  Password: 'Password',
  UserRelations: 'UserRelations',
  EntityAndUserRelations: 'EntityAndUserRelations',
  ETGAndEntityRelations: 'ETGAndEntityRelations',
  Log: 'Log',
  Fei: 'Fei',
  Carcasse: 'Carcasse',
  CarcasseCertificat: 'CarcasseCertificat',
  FeiIntermediaire: 'FeiIntermediaire',
  CarcasseIntermediaire: 'CarcasseIntermediaire',
  NotificationLog: 'NotificationLog',
  CronJob: 'CronJob'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }

        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
